module.exports = __webpack_public_path__ + "static/media/abzug_handwerker.3e5fc79f.png";